export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Administracja": "",
        "Akceptuj": "",
        "Aktywne kanały komunikacji": "",
        "Anuluj": "",
        "Błąd w kodzie MJML.": "",
        "Centrum powiadomień": "",
        "Data utworzenia": "",
        "Data wysłania": "",
        "Dodaj szablon": "",
        "Dodaj typ": "",
        "Dodaj wiadomość": "",
        "Dodaj zmienną": "",
        "Dodaj zmienne dla szablonu": "",
        "Dodane przez": "",
        "Dodawanie komunikatu": "",
        "Dodawanie szablonu powiadomień": "",
        "Dodawanie typu powiadomienia": "",
        "Edycja komunikatu": "",
        "Edycja szablonu powiadomień": "",
        "Edycja typu powiadomienia": "",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "",
        "Edytuj": "",
        "Edytuj szablon": "",
        "Edytuj typ": "",
        "Edytuj wiadomość": "",
        "ID": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "kanał wymagany": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Kanały włączone w ustawieniach aplikacji": "",
        "Kategoria": "",
        "Klucze": "",
        "Kod MJML": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja stopki oraz logo wiadomości mailowych.": "",
        "Kopiuj": "",
        "Lista jest pusta": "",
        "Logo": "",
        "Logo jest wspólne dla wszystkich wersji językowych.": "",
        "Moje dokumenty": "",
        "Nazwa": "",
        "Nazwa powiadomienia": "",
        "Nazwa szablonu": "",
        "Nazwa typu": "",
        "Nazwa zmiennej": "",
        "Nazwa zmiennej nie może być pusta.": "",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się wykonać akcji": "",
        "Nie znaleziono żadnych wyników.": "",
        "Odznacz wszystkie": "",
        "Poczta wychodząca": "",
        "Podgląd HTML": "",
        "Podgląd szablonu": "",
        "Pokaż w koncie użytkownika": "",
        "Potwierdź akceptację": "",
        "Potwierdzenie usunięcia": "",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie zbiorowe zostało dodane.": "",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "",
        "Powiększ kod MJML": "",
        "Powiększ podgląd": "",
        "Powrót": "",
        "Stan powiadomienia": "",
        "Status dokumentu został zmieniony.": "",
        "Status powiadomienia": "",
        "Stopka": "",
        "Stopkę ustawiasz osobno dla każdej wersji językowej.": "",
        "Strona główna": "",
        "System": "",
        "System powiadomień": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony email": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Testuj": "",
        "Treść": "",
        "Typ powiadomienia": "",
        "Typy powiadomień": "",
        "Tytuł": "",
        "Tytuł powiadomienia": "",
        "Ustawienia": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Usuń": "",
        "Wczytywanie danych…": "",
        "Wersje": "",
        "Włącznik wysyłki wszystkich powiadomień.": "",
        "Włączone": "",
        "Włączony": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wszystko": "",
        "wybierz": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "wybierz...": "",
        "Wybór języka": "",
        "Wyłączony": "",
        "Wymagane": "",
        "Wymagane kanały pozostają zawsze aktywne.": "",
        "Wyślij do": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wysyłaj tym kanałem": "",
        "Wysyłka wiadomości": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz ustawienia": "",
        "Zaznacz wszystkie": "",
        "Zmiana hasła": "",
        "Zmienne": ""
    }
};
